<template lang="pug">
.findVideoDialog

    v-dialog(v-model="dialog", scrollable max-width="740")
      template(v-slot:activator="{ on, attrs }")
        v-btn.my-4(v-if="size === 'big'" depressed, color="accent", v-bind="attrs", v-on="on")
          v-icon(left) library_add
          | {{$t('create.chooseClips')}}
        
        v-card.dragItem.add-card.d-flex.justify-center.align-center(v-else v-bind="attrs", v-on="on" elevation="0" height="100" min-width="60")
          v-icon(size="30") add
        //- v-btn(v-else icon, color="primaray", v-bind="attrs", v-on="on")
        //-   v-icon library_add
      v-card.rounded-lg(color="grey lighten-4")
        
        v-card-text.px-0.pb-0(style="max-height: 80vh; overflow: hidden")
          findVideo(element="CLIP", buttonOrigin="creator")
        v-divider
        v-card-actions 
          v-spacer 
          v-btn(depressed color="accent" @click="dialog = false") {{$t('general.done')}}
</template>

<script>
import FindVideo from "@/components/search/FindVideo";
export default {
  components: {
    FindVideo,
  },
  props: ["size"],
  data() {
    return {
      dialog: false,
    };
  },
};
</script>
<style lang="sass" scoped>
@import '@/assets/style/main'
.dragItem
  border-radius: 12px
  margin: 0 6px
  width: 90%
  overflow: hidden
  position: relative
  background: $light
  @media only screen and (max-width: 600px)
    margin: 10px auto !important

  // border-radius: 12px
  // width: 100%
  // // transform: scale(0.95)
  // margin: 0 6px
  // transition: all 0.4s ease
  &::before
    opacity: 0 !important
</style>
